import {
	ChangeDetectorRef,
	Component,
	Inject, // EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
	L10N_CONFIG,
	L10N_LOCALE,
	L10nConfig,
	L10nLocale,
	L10nTranslatePipe,
	L10nTranslationService
} from 'angular-l10n';

import { HttpClient } from "@angular/common/http";
import { FormControl, FormsModule } from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { AuthService } from "../../shared/auth.service";
import { BreadcrumbService } from "../../shared/breadcrumb/breadcrumb.service";
import { LoggerService } from "../../shared/logger.service";
import { SessionService } from "../../shared/session.service";
import { Tabelle } from "../immerdrin/tabelle/tabelle";
import { DatePipe } from "@angular/common";
import { FlexModule, MediaObserver } from "@ngbracket/ngx-layout";
import { CsvConfiguration, Ng2CsvModule, Ng2CsvService } from "ng2csv";
import { ErrorHelper } from "../../shared/error.helper";
import { Logprotokoll } from "./logprotokoll.model";

const PATH_FILE = 'app/protected/logprotokoll/logprotokoll.component.ts';
const OBJ_LNG_NAME = 'logprotokoll';
const BACKEND_PATH_PREFIX = 'lp';

@Component({
    selector: 'oase-logprotokoll',
    templateUrl: './logprotokoll.component.html',
    styleUrls: ['./logprotokoll.component.css'],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule, Ng2CsvModule, FlexModule]

})
export class LogprotokollComponent extends Tabelle<Logprotokoll> {

	logprotokolls: Logprotokoll[] = new Array<Logprotokoll>();
	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	public filteredLogprotokolls: ReplaySubject<Logprotokoll[]> = new ReplaySubject<Logprotokoll[]>(1);
    protokollVon: Date;
    protokollBis: Date;
	aktionen: string[] = new Array<string>();
	aktuelleAktion: string = 'Alles';

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public datepipe: DatePipe,
		public ng2CsvService: Ng2CsvService,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/lp",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: 'zeitstempel',
				DEFAULT_SORT_START: 'desc',
				extraDataForAdding: { }
			}
		);
		this.displayedColumns = ['zeitstempel', 'aktion', 'text', 'browser','ip','benutzer'];
	    this.getAktionen();
	    this.breadcrumbService.addFriendlyNameForRoute('/protected/lp', this.translation.translate('menue.verwaltung.logprotokoll'));
	}

	getApiParams() {
		return "seite";
	}

	formQueryString() {
		let queryParts: string[] = [];
		if (this.protokollVon != null)
			queryParts.push("von=" + this.datepipe.transform(this.protokollVon, 'yyyy-MM-dd'));
		if (this.protokollBis != null)
			queryParts.push("bis=" + this.datepipe.transform(this.protokollBis, 'yyyy-MM-dd'));
		if (this.aktuelleAktion != null)
			queryParts.push("aktion=" + this.aktuelleAktion);
		let query = queryParts.join("&");
		console.log("query="+query);
		return query;
	}

	getAktionen() {
				this._logger.log(PATH_FILE + ' - getAktionen Begin für URL: '+this.REST_API);

				this.http
					.get<string[]>(this.REST_API + '/getAktionen')
					 // Um mehrfachaufrufe zu verhindern
					.subscribe({
						next: (data) => {
							this.aktionen = data;
							this.aktionen.push('Alles');
							this._logger.log(PATH_FILE + ' - getAktionen End', this.aktionen);
						},
						error: (err) => {
							ErrorHelper.handleError(err,"Fehler beim holen der Aktionen",this._logger, this.translation)
						},
						complete: () => {
							this._logger.log(PATH_FILE + ' - Holen der Aktionen abgeschlossen')
						}
					});
	}



		export(){
			this.http
				.get<Logprotokoll[]>(this.REST_API + '/liste?'+this.formQueryString())
				 // Um mehrfachaufrufe zu verhindern
				.subscribe({
					next: (data) => {
						let allProtocolData = data;
						let exportData: Logprotokoll[] = new Array<Logprotokoll>();
						for(const element of allProtocolData){
						  let obj: Logprotokoll = new Logprotokoll();
						  obj.datum = this.datepipe.transform(element.zeitstempel, 'yyyy-MM-dd');
						  obj.aktion = element.aktion;
						  obj.text = element.text;
						  obj.browser = element.browser;
						  obj.ip = element.ip;
						  obj.benutzer = element.benutzer;
						  exportData.push(obj);
						}
						const csvConfig = new CsvConfiguration();
						csvConfig.delimiter = ';';
						csvConfig.includeHeaderLine = true;
						this.ng2CsvService.download(exportData, "Logprotokoll", undefined, csvConfig );
						this.ladedaten = false;
					}});
		}
	}